module.exports = __webpack_public_path__ + "thumbnail-f0902e04.webp";